export class SelectedFilter {
  constructor(
    public id: string,
    public description: string,
    public deselectCallback
  ) {}
}
